module.exports = __webpack_public_path__ + "img/Screenshots-of-FM-WhatsApp.e70d1e03.webp";